import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const STATE_PROVINCE_REGION_MAX_LENGTH = 50;

export const STATE_PROVINCE_REGION_SCHEMA_FIELD_NAME = "stateProvinceRegion";
export const getStateProvinceRegionFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .required()
    .max(STATE_PROVINCE_REGION_MAX_LENGTH)
    .alphaHyphenPeriodSpace()
    .label(i18n("StateProvinceRegionFormField__LABEL").toLowerCase());
